import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { InputTextModule } from 'primeng/inputtext';
import { FloatLabelModule } from 'primeng/floatlabel';
import { CheckboxModule } from 'primeng/checkbox';
import { user } from 'src/app/models/user.model';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { UpdatePersonalInformationDTO } from 'src/app/models/update-user/update-personal-information.model';
import { UpdatePersonalInformationAddressDTO } from 'src/app/models/update-user/update-personal-information-address.model';
import { FieldsetModule } from 'primeng/fieldset';

@Component({
  selector: 'app-update-userdata-dialog',
  standalone: true,
  imports: [
    InputTextModule,
    FloatLabelModule,
    CheckboxModule,
    ReactiveFormsModule,
    ButtonModule,
    FieldsetModule,
  ],
  templateUrl: './update-userdata-dialog.component.html',
  styleUrl: './update-userdata-dialog.component.scss',
})
export class UpdateUserdataDialogComponent implements OnInit {
  @Input() userData: user;
  // Wird von der Navbar gesetzt, solange der Speichervorgang läuft
  @Input() saving = false;
  @Output() close = new EventEmitter<UpdatePersonalInformationDTO>();

  constructor(private fb: FormBuilder) {}

  updateForm!: FormGroup;

  ngOnInit(): void {
    const residence = this.userData.residences?.[0];

    this.updateForm = this.fb.group({
      firstname: [this.userData.firstname ?? '', Validators.required],
      lastname: [this.userData.lastname ?? '', Validators.required],
      street: [residence?.street ?? ''],
      postal: [residence?.postalCode ?? ''],
      city: [residence?.city ?? ''],
      phone: [residence?.phoneNumber ?? ''],
      email: [
        this.userData.email ?? '',
        [Validators.email, Validators.required],
      ],
      checkbox: [this.userData.notifications ?? true],
    });
  }

  submit() {
    if (!this.updateForm.valid || this.saving) return;

    const data: UpdatePersonalInformationDTO = {
      id: this.userData.userId,
      firstname: this.updateForm.value.firstname,
      lastname: this.updateForm.value.lastname,
      residence: this.buildResidence(),
      email: this.updateForm.value.email,
      notifications: this.updateForm.value.checkbox,
    };
    this.close.emit(data);
  }

  // undefined nur ohne jede Adresse - sonst leere Felder mitschicken, damit sich eine
  // gespeicherte Adresse leeren lässt. "" statt null: street/city sind in der DB NOT NULL.
  private buildResidence(): UpdatePersonalInformationAddressDTO | undefined {
    const residence: UpdatePersonalInformationAddressDTO = {
      street: this.normalize(this.updateForm.value.street),
      postal: this.normalize(this.updateForm.value.postal),
      city: this.normalize(this.updateForm.value.city),
      phone: this.normalize(this.updateForm.value.phone),
    };

    const isEmpty = Object.values(residence).every((value) => value === '');
    const hasStoredResidence = !!this.userData.residences?.length;

    return isEmpty && !hasStoredResidence ? undefined : residence;
  }

  private normalize(value: string | null | undefined): string {
    return value?.trim() ?? '';
  }
}
